// import
import Account from "views/Dashboard/Account.js";
import Tools from "views/Dashboard/Tools.js";

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
  HelpIcon,
  SettingsIcon,
} from "components/Icons/Icons";

var dashRoutes = [
  {
    path: "/tools",
    name: "Tools",
    rtlName: "لوحة القيادة",
    icon: <HelpIcon color="inherit" />,
    component: Tools,
    layout: "/clerk",
  },
  {
    path: "/account",
    name: "Account",
    rtlName: "لوحة القيادة",
    icon: <SettingsIcon color="inherit" />,
    secondaryNavbar: true,
    component: Account,
    layout: "/clerk",
  },
];
export default dashRoutes;
